import { useCallback } from 'react';

import { PureSwitch } from '@/components/form/Switch';
import { useGrid } from '@Components/Grid';
import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function GlobalToggle({ info }) {
  const { row, field, value } = getInfo(info)
  const { events: { handleUpdateEntry } } = useGrid()

  const handleUpdateActive = useCallback(() => {
    handleUpdateEntry({ id: row.id, [field]: !value })
  }, [handleUpdateEntry, field, row, value])

  if (row.type === 'not-ip-country' || row.type === 'ip-country') {
    return null
  }

  return <PureSwitch value={value} onChange={handleUpdateActive} />
}
